const isClosed = (dataIn, timeDiffIn) => {
  let timeDiff = timeDiffIn ? timeDiffIn : Date.now() - dataIn.dateNow
  let timeNow = new Date(
    Date.now() + ((0 + dataIn.timeZone) * 3600000 - timeDiff)
  )
  //let timeNow = new Date(
  //  Date.parse("2025-04-13T22:54:30") +
  //    ((0 + dataIn.timeZone) * 3600000 - timeDiff)
  //)
  let days = [
    {
      O: "sunO",
      C: "sunC",
      Ot: "sunOt",
      Ct: "sunCt",
      isClosed: "isSunC",
      isSecondt: "isSunSt",
      name: "Sunday",
    },
    {
      O: "monO",
      C: "monC",
      Ot: "monOt",
      Ct: "monCt",
      isClosed: "isMonC",
      isSecondt: "isMonSt",
      name: "Monday",
    },
    {
      O: "tueO",
      C: "tueC",
      Ot: "tueOt",
      Ct: "tueCt",
      isClosed: "isTueC",
      isSecondt: "isTueSt",
      name: "Tuesday",
    },
    {
      O: "wedO",
      C: "wedC",
      Ot: "wedOt",
      Ct: "wedCt",
      isClosed: "isWedC",
      isSecondt: "isWedSt",
      name: "Wednesday",
    },
    {
      O: "thuO",
      C: "thuC",
      Ot: "thuOt",
      Ct: "thuCt",
      isClosed: "isThuC",
      isSecondt: "isThuSt",
      name: "Thursday",
    },
    {
      O: "friO",
      C: "friC",
      Ot: "friOt",
      Ct: "friCt",
      isClosed: "isFriC",
      isSecondt: "isFriSt",
      name: "Friday",
    },
    {
      O: "satO",
      C: "satC",
      Ot: "satOt",
      Ct: "satCt",
      isClosed: "isSatC",
      isSecondt: "isSatSt",
      name: "Saturday",
    },
  ]
  let timeNowDay = timeNow.getUTCDay()
  let timeNowHours = timeNow.getUTCHours()
  let timeNowMinutes = timeNow.getUTCMinutes()
  let testTime = timeNowHours * 60 + timeNowMinutes

  const getDateObj = timeIn => {
    let fullYear = timeIn.getUTCFullYear()
    let monthInd = timeIn.getUTCMonth()
    let dayOfMonth = timeIn.getUTCDate()
    let dayOfWeek = timeIn.getUTCDay()
    let label = `${dayOfMonth < 10 ? `0${dayOfMonth}` : `${dayOfMonth}`}/${
      monthInd + 1 < 10 ? `0${monthInd + 1}` : `${monthInd + 1}`
    }/${fullYear}`
    return {
      javaDateUTC: timeIn,
      fullYear,
      monthInd,
      dayOfMonth,
      dayOfWeek,
      label,
    }
  }

  const checkDayIndex = dayIndexIn => {
    if (dayIndexIn > 6) {
      let dayIndexOut = dayIndexIn
      for (dayIndexOut; dayIndexOut > 6; dayIndexOut = dayIndexOut - 7) {}
      return dayIndexOut
    } else {
      return dayIndexIn
    }
  }

  const getDayName = dayIndexIn => {
    return days[checkDayIndex(dayIndexIn)].name
  }

  const getTime = (dayIndexIn, openOrClose) => {
    return dataIn[`${days[checkDayIndex(dayIndexIn)][openOrClose]}`]
  }

  // ---- MODIFIED: Added buffer check in isOpenSecond ----
  const isOpenSecond = (testTimeIn, dayIndex, timeNowIn) => {
    const openT = getTime(checkDayIndex(dayIndex), "Ot")
    const closeT = getTime(checkDayIndex(dayIndex), "Ct")
    const isClosedFlag = getTime(checkDayIndex(dayIndex), "isClosed")
    // Ensure that there's enough time left to place an order in the second shift
    const canPlaceOrder =
      testTimeIn + dataIn.minOrderMinutesWindow + dataIn.orderMinutesBuffer <=
      closeT
    return (
      getTime(checkDayIndex(dayIndex), "isSecondt") &&
      testTimeIn >= openT &&
      testTimeIn <= closeT &&
      !isClosedFlag &&
      canPlaceOrder &&
      !dataIn.closedDates.includes(getDateObj(timeNowIn).label)
    )
  }

  const isOpen = (testTimeIn, dayIndex, timeNowIn) => {
    return (
      ((testTimeIn >= getTime(checkDayIndex(dayIndex), "O") &&
        testTimeIn <= getTime(checkDayIndex(dayIndex), "C") &&
        !getTime(checkDayIndex(dayIndex), "isClosed")) ||
        (getTime(checkDayIndex(dayIndex), "isSecondt") &&
          testTimeIn >= getTime(checkDayIndex(dayIndex), "Ot") &&
          testTimeIn <= getTime(checkDayIndex(dayIndex), "Ct") &&
          !getTime(checkDayIndex(dayIndex), "isClosed"))) &&
      !dataIn.closedDates.includes(getDateObj(timeNowIn).label)
    )
  }

  const isDateOpen = (dayIndex, timeIn) => {
    return (
      !getTime(checkDayIndex(dayIndex), "isClosed") &&
      !dataIn.closedDates.includes(getDateObj(timeIn).label)
    )
  }

  const getSlots = dayOfWeekIn => {
    let steps = []
    let openTime = getTime(dayOfWeekIn, "O")
    let closeTime = getTime(dayOfWeekIn, "C")

    let stepsCount = Math.floor(
      (closeTime - openTime) / dataIn.orderMinutesWindow
    )
    for (let i = 0; i <= stepsCount; i++) {
      let slotTime = i * dataIn.orderMinutesWindow + openTime
      steps.push(slotTime >= 1440 ? 1439 : slotTime <= 0 ? 1 : slotTime)
    }

    // Add slots for the second opening time if available
    if (getTime(dayOfWeekIn, "isSecondt")) {
      let openTimeT = getTime(dayOfWeekIn, "Ot")
      let closeTimeT = getTime(dayOfWeekIn, "Ct")

      let stepsCountT = Math.floor(
        (closeTimeT - openTimeT) / dataIn.orderMinutesWindow
      )
      for (let i = 0; i <= stepsCountT; i++) {
        let slotTime = i * dataIn.orderMinutesWindow + openTimeT
        steps.push(slotTime >= 1440 ? 1439 : slotTime <= 0 ? 1 : slotTime)
      }
    }

    return steps
  }

  const getSurcharge = timeIn => {
    let surcharge = {
      phSurchargeRate: 0,
      sunSurchargeRate: 0,
      satSurchargeRate: 0,
    }
    if (
      dataIn.phSurchargeDates.includes(getDateObj(timeIn).label) &&
      dataIn.isPhSurcharge
    ) {
      surcharge.phSurchargeRate = dataIn.phSurchargeRate
    } else if (getDateObj(timeIn).dayOfWeek === 0 && dataIn.isSunSurcharge) {
      surcharge.sunSurchargeRate = dataIn.sunSurchargeRate
    } else if (getDateObj(timeIn).dayOfWeek === 6 && dataIn.isSatSurcharge) {
      surcharge.satSurchargeRate = dataIn.satSurchargeRate
    }
    return surcharge
  }

  const getOrderWindows = () => {
    let orderWindowsOut = []
    let currentTimeTotal = timeNowHours * 60 + timeNowMinutes
    // Determine the earliest new order time for today (in minutes)
    let currentOrderBufferTime =
      currentTimeTotal +
      dataIn.minOrderMinutesWindow +
      dataIn.orderMinutesBuffer

    // Retrieve first shift times for today
    let firstShiftOpen = getTime(timeNowDay, "O")
    let firstShiftClose = getTime(timeNowDay, "C")

    // Retrieve second shift times for today if available
    let hasSecondShift = Boolean(getTime(timeNowDay, "isSecondt"))
    let secondShiftOpen = hasSecondShift ? getTime(timeNowDay, "Ot") : null
    let secondShiftClose = hasSecondShift ? getTime(timeNowDay, "Ct") : null

    // ----------------------------
    // Compute Today's Slots
    // ----------------------------
    let firstShiftSlots = []
    if (currentOrderBufferTime < firstShiftClose) {
      // The starting time is the later of today's open or current order buffer time.
      let startingTime = Math.max(currentOrderBufferTime, firstShiftOpen)
      // Round startingTime up to the next multiple of orderMinutesWindow.
      let remainder = startingTime % dataIn.orderMinutesWindow
      if (remainder !== 0) {
        startingTime += dataIn.orderMinutesWindow - remainder
      }
      // Generate slots from startingTime up to (and including) firstShiftClose.
      for (
        let t = startingTime;
        t <= firstShiftClose;
        t += dataIn.orderMinutesWindow
      ) {
        // ADJUSTED SLOT: adjust t if 0 or 1440.
        let slotTime = t >= 1440 ? 1439 : t <= 0 ? 1 : t
        firstShiftSlots.push(slotTime)
      }
    }

    let secondShiftSlots = []
    if (hasSecondShift && currentOrderBufferTime < secondShiftClose) {
      let startingTime = Math.max(currentOrderBufferTime, secondShiftOpen)
      let remainder = startingTime % dataIn.orderMinutesWindow
      if (remainder !== 0) {
        startingTime += dataIn.orderMinutesWindow - remainder
      }
      for (
        let t = startingTime;
        t <= secondShiftClose;
        t += dataIn.orderMinutesWindow
      ) {
        // ADJUSTED SLOT:
        let slotTime = t >= 1440 ? 1439 : t <= 0 ? 1 : t
        secondShiftSlots.push(slotTime)
      }
    }

    // Combine today's slots from both shifts, de-duplicate and sort.
    let dayOneSlots = firstShiftSlots.concat(secondShiftSlots)
    dayOneSlots = [...new Set(dayOneSlots)].sort((a, b) => a - b)

    if (dayOneSlots.length > 0) {
      let dayNameCalcOne = getDayName(timeNowDay)
      orderWindowsOut.push({
        date: {
          ...getDateObj(timeNow),
          dayLabel: "Today",
          dayName: dayNameCalcOne,
        },
        dayLabel: "Today",
        dayName: dayNameCalcOne,
        slots: dayOneSlots,
        surcharge: getSurcharge(timeNow),
      })
    }

    // ----------------------------
    // Process Future Days
    // ----------------------------
    for (let i = 1; i < dataIn.orderDaysAhead; i++) {
      let newDate = new Date(Date.parse(timeNow) + i * 24 * 3600000)
      let newDateObj = getDateObj(newDate)
      if (isDateOpen(newDateObj.dayOfWeek, newDate)) {
        let slotsOut = []
        // For tomorrow (i === 1), adjust the start times based on the buffer.
        if (i === 1) {
          // Calculate "tomorrow buffer" by subtracting 1440 (minutes in a day) from currentOrderBufferTime.
          let tomorrowBuffer = currentOrderBufferTime - 1440

          // --- First Shift for Tomorrow ---
          let tomorrowFirstShiftOpen = dataIn[days[newDateObj.dayOfWeek].O]
          let tomorrowFirstShiftClose = dataIn[days[newDateObj.dayOfWeek].C]
          let startTime = Math.max(tomorrowBuffer, tomorrowFirstShiftOpen)
          let remainder = startTime % dataIn.orderMinutesWindow
          if (remainder !== 0) {
            startTime += dataIn.orderMinutesWindow - remainder
          }
          let firstShiftTomorrow = []
          for (
            let t = startTime;
            t <= tomorrowFirstShiftClose;
            t += dataIn.orderMinutesWindow
          ) {
            // ADJUSTED SLOT:
            let slotTime = t >= 1440 ? 1439 : t <= 0 ? 1 : t
            firstShiftTomorrow.push(slotTime)
          }

          // --- Second Shift for Tomorrow (if available) ---
          let secondShiftTomorrow = []
          if (getTime(newDateObj.dayOfWeek, "isSecondt")) {
            let tomorrowSecondShiftOpen = dataIn[days[newDateObj.dayOfWeek].Ot]
            let tomorrowSecondShiftClose = dataIn[days[newDateObj.dayOfWeek].Ct]
            let startTime2 = Math.max(tomorrowBuffer, tomorrowSecondShiftOpen)
            let remainder2 = startTime2 % dataIn.orderMinutesWindow
            if (remainder2 !== 0) {
              startTime2 += dataIn.orderMinutesWindow - remainder2
            }
            for (
              let t = startTime2;
              t <= tomorrowSecondShiftClose;
              t += dataIn.orderMinutesWindow
            ) {
              // ADJUSTED SLOT:
              let slotTime = t >= 1440 ? 1439 : t <= 0 ? 1 : t
              secondShiftTomorrow.push(slotTime)
            }
          }

          slotsOut = [
            ...new Set(firstShiftTomorrow.concat(secondShiftTomorrow)),
          ].sort((a, b) => a - b)
        } else {
          // For days beyond tomorrow, use the full day slots computed by getSlots.
          slotsOut = getSlots(newDateObj.dayOfWeek)
        }

        if (slotsOut.length > 0) {
          let dayNameCalcTwo = getDayName(newDateObj.dayOfWeek)
          orderWindowsOut.push({
            date: {
              ...newDateObj,
              dayLabel: i === 1 ? "Tomorrow" : null,
              dayName: dayNameCalcTwo,
            },
            dayLabel: i === 1 ? "Tomorrow" : null,
            dayName: dayNameCalcTwo,
            slots: slotsOut,
            surcharge: getSurcharge(newDate),
          })
        }
      }
    }
    return orderWindowsOut
  }

  const getTableList = () => {
    let tables = []
    let count = 0
    for (let i = 0; i < dataIn.tablesEndingNumber; i++) {
      if (!dataIn.notAvailTables.includes(dataIn.tablesStartingNumber + i)) {
        tables[count] = dataIn.tablesStartingNumber + i
        count++
      }
    }
    return tables
  }

  const getMinutesToClose = () => {
    let minutesToClose = 0
    if (
      isOpenSecond(testTime, timeNowDay, timeNow) &&
      getTime(checkDayIndex(timeNowDay + 1), "O") === 0 &&
      !getTime(checkDayIndex(timeNowDay + 1), "isClosed")
    ) {
      minutesToClose =
        1440 - testTime + dataIn[`${days[checkDayIndex(timeNowDay + 1)].C}`]
    } else if (isOpenSecond(testTime, timeNowDay, timeNow)) {
      minutesToClose = dataIn[`${days[timeNowDay].Ct}`] - testTime
    } else {
      minutesToClose = dataIn[`${days[timeNowDay].C}`] - testTime
    }
    return minutesToClose
  }

  const getTimeNowObj = () => {
    return { timeNowDay, timeNowHours, timeNowMinutes, testTime }
  }

  const testTimeFunc = () => {
    if (isOpen(testTime, timeNowDay, timeNow)) {
      return {
        isResOutOfHours: false,
        minutesToClose: getMinutesToClose(),
        surcharge: getSurcharge(timeNow),
        orderWindows: getOrderWindows(),
        tableList: getTableList(),
        timeNowObj: getTimeNowObj(),
      }
    } else {
      return {
        isResOutOfHours: true,
        minutesToClose: 0,
        surcharge: getSurcharge(timeNow),
        orderWindows: getOrderWindows(),
        tableList: getTableList(),
        timeNowObj: getTimeNowObj(),
      }
    }
  }

  return testTimeFunc()
}

export default isClosed
